/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDName
 */
export interface IDName {
    /**
     * 
     * @type {string}
     * @memberof IDName
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IDName
     */
    name: string;
}

/**
 * Check if a given object implements the IDName interface.
 */
export function instanceOfIDName(value: object): value is IDName {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function IDNameFromJSON(json: any): IDName {
    return IDNameFromJSONTyped(json, false);
}

export function IDNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDName {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function IDNameToJSON(json: any): IDName {
    return IDNameToJSONTyped(json, false);
}

export function IDNameToJSONTyped(value?: IDName | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

